
import CheckboxField from '@/components/processing_steps/commons/fields/CheckboxField.vue'
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ProjectSummary from '@/components/processing_steps/project/forms/completition_forms/ProjectSummary.vue'
import IconAndText from '@/components/processing_steps/banners/IconAndText.vue'
import CompletitionLayout from '@/components/processing_steps/commons/CompletitionLayout.vue'
import RadioButtons from '@/components/processing_steps/commons/fields/RadioButtons.vue'

@Component({
  components: {
    FormContainer,
    CheckboxField,
    ProjectSummary,
    IconAndText,
    CompletitionLayout,
    RadioButtons
  }
})
export default class AccountPublishProjectForm extends Vue {
  @Prop() summaryItems!: { title: string, items: { title: string, values: string[]}[]}[]
  @Prop() termsAccepted!: boolean
  @Prop() projectDetailUrl!: string
  @Prop() isComplete!: boolean
  @Prop() termsAndPrivacyHtml!: string
  @Prop() isLimitedToOwnFundingPages!: boolean
  @Prop() orgaWaitingForReview!: boolean

  localIsLimitedToOwnFundingPages = false

  get statusExplanation (): string {
    if (this.isComplete) {
      if (this.orgaWaitingForReview) {
        return this.$gettext('This project is complete.')
      }
      return this.$gettext('This project is complete. You can publish it.')
    } else {
      return this.$gettext('The data on this project is incomplete.')
    }
  }

  mounted (): void {
    this.localIsLimitedToOwnFundingPages = this.isLimitedToOwnFundingPages
  }

  @Watch('localIsLimitedToOwnFundingPages')
  onLocalIsLimitedToOwnFundingPagesChange (newValue: boolean): void {
    this.$emit('update:isLimitedToOwnFundingPages', newValue)
  }

  @Watch('isLimitedToOwnFundingPages')
  onIsLimitedToOwnFundingPagesChange (newValue: boolean): void {
    this.localIsLimitedToOwnFundingPages = newValue
  }

  gotoProjectDetailPage (): void {
    window.open(this.projectDetailUrl, '_blank')
  }
}
